import React from 'react';
import Grid2 from '@mui/material/Grid2';

const DSGrid = (props: React.ComponentProps<typeof Grid2>) => {
  return <Grid2 {...props} />;
};

export default DSGrid;
